import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Component({
	selector: "marketing-material",
	templateUrl: "./marketing-material.component.html",
	styleUrls: ["./marketing-material.component.scss"],
})
export class MarketingMaterialComponent {}
